import { JournalId } from 'types';

export const DAILY_SCHEDULE = (journalId: JournalId) =>
    `/api/v1/journals/${journalId}/schedules/daily`;
export const WEEKLY_SCHEDULE = (journalId: JournalId) =>
    `/api/v1/journals/${journalId}/schedules/weekly`;
